import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { SPECIAL_PRODUCT_TYPES } from 'swag-common/constants/product.constants';
import { BOX_NOTECARD_STEPS } from '../../../../../redux/box-notecard-editor/box-notecard-editor.reducer';
import { moveToPopupStep, closeBoxNotecardEditorPopup } from '../../../../../redux/box-notecard-editor/box-notecard-editor.actions';
import { toggleSpecialProductInBox } from '../../../../../redux/box-builder/box-builder.actions';
import { selectedBoxItemsIdSelector } from '../../../../../redux/box-notecard-editor/box-notecard-editor.selectors';
import { isNotecardLoadingSelector, notecardColorSelector, notecardLogoPreviewSelector } from '../../../../../redux/notecard-editor/notecard-editor.selectors';
import { changeNotecardColor, deleteNotecardLogo, uploadNotecardLogo } from '../../../../../redux/notecard-editor/notecard-editor.actions';
import { LogoUploadStepComponent } from './logo-upload-step';
const mapStateToProps = createStructuredSelector({
  boxItemsId: selectedBoxItemsIdSelector,
  color: notecardColorSelector,
  logo: notecardLogoPreviewSelector,
  isLogoLoading: isNotecardLoadingSelector
});
const mapDispatchToProps = dispatch => ({
  onNext: () => {
    dispatch(moveToPopupStep(BOX_NOTECARD_STEPS.TEXT_CONTENT));
  },
  onBack: boxItemsId => {
    //UPDATE CART WITHOUT NOTECARD
    dispatch(toggleSpecialProductInBox(boxItemsId, SPECIAL_PRODUCT_TYPES.BOX_NOTECARD, {
      isNotecardPicked: false
    }));
    dispatch(closeBoxNotecardEditorPopup());
  },
  onColorChange: color => {
    dispatch(changeNotecardColor(color));
  },
  onLogoUpload: file => {
    dispatch(uploadNotecardLogo(file));
  },
  onLogoDelete: () => {
    dispatch(deleteNotecardLogo());
  },
  onProvideDesignLater: () => {
    dispatch(moveToPopupStep(BOX_NOTECARD_STEPS.CONFIRM_PROVIDE_LATER));
  }
});
export const LogoUploadStep = connect(mapStateToProps, mapDispatchToProps)(LogoUploadStepComponent);